// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8y-4";
export var collapsed = "_8y-1";
export var headerBar = "_8y-0";
export var leftHeaderContent = "_8y-3";
export var subjectContainer = "_8y-2";